import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getOwnerRecordSlice = createSlice({
    name: 'Ownerrecord',
    initialState: {
        data: [],
        statusdata: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchOwnerRecord.pending, (state, action) => {
                state.statusdata = STATUSES.LOADING;
            })
            .addCase(fetchOwnerRecord.fulfilled, (state, action) => {
                state.data = action.payload;
                state.statusdata = STATUSES.IDLE
            })
            .addCase(fetchOwnerRecord.rejected, (state, action) => {
                state.statusdata = STATUSES.ERROR;
            })
    }
});



export const { setOwner, setStatus } = getOwnerRecordSlice.actions;
export default getOwnerRecordSlice.reducer;

export const fetchOwnerRecord = createAsyncThunk('/OwnerHistory/fetch', async ({
    id,
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength }) => {
    const finalId = id?._id || id;
    const res = await axios.get(`${getBaseUrl()}/OwnerHistoryForStatistics/${finalId}?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind}&RaceType=${RaceType === undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}`);
    const OwnerstatsData = res.data;
    return OwnerstatsData.data;
})